import React from "react";

export default function RoleGuard({ user, allow, children, fallback }) {
  if (!user || !user.role) return null;
  if (!allow || !Array.isArray(allow)) return null;
  if (allow.includes(user.role)) return <>{children}</>;
  return fallback || null;
}

export function getVisibleTabs(role) {
  const tabs = [
    { id: "dashboard", label: "Dashboard", icon: "\u25C9", roles: ["super_admin", "admin", "operator", "viewer", "employer"], description: "KPIs, weight trends, risk distribution, adherence, survival curves, ROI, and clinical anomaly alerts across your entire patient population." },
    { id: "initiation", label: "Initiation", icon: "\u25B6", roles: ["super_admin", "admin", "operator"], description: "Candidate identification, prior authorization intelligence, enrollment tracking, and new patient onboarding metrics." },
    { id: "maintenance", label: "Maintenance", icon: "\u27F3", roles: ["super_admin", "admin", "operator"], description: "Adherence monitoring, weight trajectory tracking, dropout risk scoring, intervention workflows, and care coordination." },
    { id: "discontinuation", label: "Discontinuation", icon: "\u25FC", roles: ["super_admin", "admin", "operator"], description: "Deprescribing readiness, weight regain monitoring, post-medication outcomes, and maintenance success prediction." },
    { id: "patients", label: "Patients", icon: "\u2315", roles: ["super_admin", "admin", "operator", "viewer"], description: "Search, filter, and view individual patient profiles with risk scores, weight charts, observation timelines, and evidence packets." },
    { id: "analytics", label: "Analytics", icon: "\u25EB", roles: ["super_admin", "admin", "operator"], description: "Cohort comparisons, time-to-milestone analysis, ROI deep dives, dropout trends, and exportable PDF/CSV reports." },
    { id: "admin", label: "Admin", icon: "\u2699", roles: ["super_admin", "admin"], description: "User management, customer accounts, audit logs, data ingestion connectors, and LinkedIn content agent." },
  ];
  return tabs.filter((t) => t.roles.includes(role));
}

export function canPerform(role, action) {
  const permissions = {
    download_evidence: ["super_admin", "admin", "operator"],
    create_user: ["super_admin", "admin"],
    create_customer: ["super_admin"],
    view_audit_log: ["super_admin", "admin"],
    view_analytics: ["super_admin", "admin", "operator"],
  };
  const allowed = permissions[action];
  return allowed ? allowed.includes(role) : false;
}
